/* eslint-disable no-param-reassign */
import { SubscriptionCheck } from "../../../../../components/Access/helper/subscription/SubscriptionCheck";
import { SubscriptionScopeKey } from "../../../../../components/Access/helper/subscription/enum/SubscriptionScopeKey";
import {select} from "../../../../../shared/SagaService";

export function* parseNumberFormats(transaction, transactionType) {
    const numberFormats = yield select(state => state.List.numberFormats);
    const settings = yield select(state => state.List.settings);
    const defaultNumberFormatId = settings[`${transactionType}_number_format_id`];
    const defaultNumberFormat = numberFormats.find(i => i.id === defaultNumberFormatId)?.format;

    const invalidNumbers = [];

    const hasMultiNumberFormatSubscription =
        SubscriptionCheck.withKeys(SubscriptionScopeKey.MULTI_NUMBER_FORMAT).hasSubscriptionTo();
    const hasCustomNumberFormat = settings.custom_transaction_number_on;

    const isUsingDefault = transaction.number === defaultNumberFormat;
    const isUsingNonDefault = !isUsingDefault && numberFormats.find(num => num.format === transaction.number);
    const isUsingCustom = !numberFormats.find(num => num.format === transaction.number);

    // 1. Saved default number format ID, should NEVER throw error despite having/not subs or custom number format
    // 2. Saved non-default ID, should throw error if No subs && No custom number format.
    // 3. Saved custom, should throw error as long as there's No custom number format, no need to care about subs.
    // These logics are based on the table in this comment: https://bukku.atlassian.net/browse/ENG-3461?focusedCommentId=20043
    const cond2 = !hasCustomNumberFormat && !hasMultiNumberFormatSubscription && isUsingNonDefault;
    const cond3 = !hasCustomNumberFormat && isUsingCustom;

    if (transaction.number && (cond2 || cond3)) {
        invalidNumbers.push({
            old: transaction.number,
            new: defaultNumberFormat,
        });
        transaction.number = defaultNumberFormat;
        // transaction.number = null;
    }

    return invalidNumbers;
}
